import { BField } from 'buefy/dist/components/field';
import { BRadio } from 'buefy/dist/components/radio';
import { BCheckbox } from 'buefy/dist/components/checkbox';
import { BInput } from 'buefy/dist/components/input';
import { BSlider } from 'buefy/dist/components/slider';
import { BSelect } from 'buefy/dist/components/select';
import { BButton } from 'buefy/dist/components/button';
import { BMessage } from 'buefy/dist/components/message';
import { BNotification } from 'buefy/dist/components/notification';
import { BLoading } from 'buefy/dist/components/loading';
import { BPagination } from 'buefy/dist/components/pagination';

export default {
    components: {
        BField,
        BInput,
        BSlider,
        BRadio,
        BCheckbox,
        BSelect,
        BButton,
        BMessage,
        BNotification,
        BLoading,
        BPagination
    },
};